import React, { useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import { checkAccessPassword, setAccessPassword } from '../utils/siteAccess';

const FONT = 'Nunito, Arial, sans-serif';

const DEFAULT_LABELS = {
    en: { placeholder: 'Password', submit: 'Unlock', checking: 'Checking…', wrong: 'Wrong password.', failed: 'Could not check the password. Try again.' },
    zh: { placeholder: '密码', submit: '解锁', checking: '验证中…', wrong: '密码不对。', failed: '暂时无法验证密码，请稍后再试。' },
};

// Password box for the shared site password. Checks it with the server, then
// remembers it in this browser and calls onUnlocked().
function AccessPasswordForm({ lang = 'en', onUnlocked, accent = '#1f9d72' }) {
    const t = DEFAULT_LABELS[lang] || DEFAULT_LABELS.en;
    const [value, setValue] = useState('');
    const [status, setStatus] = useState('idle'); // idle | checking | wrong | failed

    const submit = async (e) => {
        e.preventDefault();
        if (!value) return;
        setStatus('checking');
        try {
            if (await checkAccessPassword(value)) {
                setAccessPassword(value);
                setStatus('idle');
                setValue('');
                if (onUnlocked) onUnlocked();
            } else {
                setStatus('wrong');
            }
        } catch (err) {
            setStatus('failed');
        }
    };

    return (
        <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: 1 }}>
            <TextField
                id="site-access-password"
                type="password"
                size="small"
                value={value}
                onChange={(e) => { setValue(e.target.value); if (status !== 'checking') setStatus('idle'); }}
                placeholder={t.placeholder}
                autoComplete="current-password"
                error={status === 'wrong' || status === 'failed'}
                helperText={status === 'wrong' ? t.wrong : status === 'failed' ? t.failed : ' '}
                inputProps={{ 'aria-label': t.placeholder }}
                sx={{ width: 200, '& input': { fontFamily: FONT }, '& .MuiFormHelperText-root': { fontFamily: FONT, mx: 0 } }}
            />
            <Button
                type="submit"
                variant="contained"
                disableElevation
                disabled={!value || status === 'checking'}
                startIcon={<LockOpenRoundedIcon />}
                sx={{ fontFamily: FONT, fontWeight: 700, textTransform: 'none', height: 40, background: accent, '&:hover': { background: accent, filter: 'brightness(0.92)' } }}
            >
                {status === 'checking' ? t.checking : t.submit}
            </Button>
        </Box>
    );
}

export default AccessPasswordForm;
